import React from "react";

const HeaderSocials = () => {
    return(
    <div className="home__socials">
        <a href="https://github.com/ankygautam" className="home__social-link" target= "_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-github"></i>
        </a>

        <a href="https://www.linkedin.com/in/ankur-gautam-/" className="home__social-link" target= "_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-linkedin"></i>
        </a>

        <a href="https://twitter.com/GautamAky" className="home__social-link" target= "_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-x-twitter"></i>
        </a>

        <a href="https://www.instagram.com/akygautam" className="home__social-link" target= "_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-instagram"></i>
        </a>

        <a href="https://www.facebook.com/AnkyDreamer/" className="home__social-link" target= "_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-facebook"></i>
        </a>

    </div>
    )
}

export default HeaderSocials